import { FormControl, FormLabel, Input, Select } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import InputWithBarcode from "../../../components/InputWithBarcode";

export interface NewProduct {
    name: string;
    sku: string;
    unitMeasurementId: string;
    barcode: string;
    providerIds: unknown[];
    categoriesIds: unknown[];
    hasSerialNumber: boolean;
    serialNumbers?: string[];
}

interface AddNewProduct {
    data: NewProduct;
    onChange: (data: NewProduct) => void;
    disable?: boolean;
    unitOfMeasurements: { name: string, id: string }[];
    afterNameComponent?: React.ReactElement;
    hideReset?: boolean;
}

const Product = (props: AddNewProduct) => {
    const {
        data,
        onChange
    } = props;

    const { t } = useTranslation("translations");

    return (
        <>
            <FormControl>
                <FormLabel>{t("PRODUCT_NAME")}</FormLabel>
                <Input
                    isRequired
                    isDisabled={props.disable}
                    name='product_name'
                    value={data.name}
                    onChange={(e) => onChange({
                        ...data,
                        name: e.target.value,
                        sku: e.target.value.toLocaleUpperCase().replaceAll(" ", "_")
                    })}
                    placeholder={t("PRODUCT_NAME_INPUT_PLACEHOLDER")}
                />
            </FormControl>
            <FormControl>
                {props.afterNameComponent ?? <></>}
            </FormControl>
            <FormControl>
                <FormLabel>{t("SKU")}</FormLabel>
                <Input
                    isRequired
                    isDisabled={true}
                    name='sku'
                    value={data.sku}
                    onChange={(e) => onChange({ ...data, sku: e.target.value })}
                    placeholder={t("SKU_INPUT_PLACEHOLDER")}
                />
            </FormControl>
            <FormControl>
                <FormLabel>{t("UNIT_OF_MEASUREMENT")}</FormLabel>
                <Select
                    isDisabled={props.disable}
                    onChange={(e) => { onChange({ ...data, unitMeasurementId: e.target.value }) }}
                    value={data.unitMeasurementId}
                    placeholder='Select option'
                >
                    {
                        props.unitOfMeasurements.map((c: any, index: number) => {
                            return (
                                <>
                                    <option key={index} id={c.id} value={c.id}>  {c.name} </option>
                                </>
                            )
                        })
                    }
                </Select>
            </FormControl>
            <FormControl>
                <FormLabel>{t("BARCODE")}</FormLabel>
                <InputWithBarcode
                    isRequired
                    isDisabled={props.disable}
                    value={data.barcode}
                    setValue={(e) => onChange({ ...data, barcode: e })}
                    placeholder={t("SKU_INPUT_PLACEHOLDER")}
                />
            </FormControl>
        </>
    )
}


export default Product;